import { render, staticRenderFns } from "./start-counting.vue?vue&type=template&id=638f68d1&scoped=true&"
import script from "./start-counting.vue?vue&type=script&lang=js&"
export * from "./start-counting.vue?vue&type=script&lang=js&"
import style0 from "./start-counting.vue?vue&type=style&index=0&id=638f68d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f68d1",
  null
  
)

export default component.exports